import { render, staticRenderFns } from "./NewsPosts.vue?vue&type=template&id=10ac7c54&scoped=true&"
import script from "./NewsPosts.vue?vue&type=script&lang=js&"
export * from "./NewsPosts.vue?vue&type=script&lang=js&"
import style0 from "./NewsPosts.vue?vue&type=style&index=0&id=10ac7c54&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10ac7c54",
  null
  
)

export default component.exports